"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _fetchTranslationsWithNamespaces = require("./fetchTranslationsWithNamespaces");
Object.keys(_fetchTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fetchTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fetchTranslationsWithNamespaces[key];
    }
  });
});
var _getTranslationsWithoutNamespaces = require("./getTranslationsWithoutNamespaces");
Object.keys(_getTranslationsWithoutNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTranslationsWithoutNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTranslationsWithoutNamespaces[key];
    }
  });
});
var _mergeTranslations = require("./mergeTranslations");
Object.keys(_mergeTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mergeTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mergeTranslations[key];
    }
  });
});
